import { css } from '@emotion/react'
import { ExternalStyles, Flow, Spinner, Text, Theme, useTheme } from 'bold-ui'

interface LoadingIndicatorProps {
  message?: string
  style?: ExternalStyles
}

export function LoadingIndicator(props: LoadingIndicatorProps) {
  const { message = 'Carregando...', style } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Flow direction='vertical' gap={0.5} style={[styles.root, style]}>
      <Spinner size={2} borderWidth={3} style={styles.spinner} />

      {message && (
        <Text color='primary' fontWeight='bold'>
          {message}
        </Text>
      )}
    </Flow>
  )
}

const createStyles = (theme: Theme) => ({
  root: css`
    text-align: center;
  `,
  spinner: css`
    color: ${theme.pallete.primary.main};
  `,
})
